import DOMPurify from "dompurify";
import { marked } from "marked";
import { useMemo } from "react";

/**
 * CommonMark, rendered.
 *
 * Documents are Markdown (ADR 000011) and were being shown as their source, so
 * a treatment read as "## What is this?" rather than a heading. That is the
 * document somebody is meant to actually read.
 *
 * Sanitised on the way out. The author is usually the reader here, but a space
 * has members, and "the only person who can write this is trusted" is the
 * assumption every stored-XSS writeup opens with.
 */
export function Markdown({ children }: { children: string }) {
  const html = useMemo(() => {
    const raw = marked.parse(children, { async: false, gfm: true, breaks: false });
    return DOMPurify.sanitize(raw, {
      // A document, not a page: no scripts, no styles, no embedded frames.
      FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form", "input"],
      FORBID_ATTR: ["style", "onerror", "onload"],
    });
  }, [children]);

  return <div className="markdown" dangerouslySetInnerHTML={{ __html: html }} />;
}
